export const accountStatuses = {
    unknown: 'Отсутствует',
    valid: 'Активный',
    invalid: 'Требуется авторизация'
}